export const MAX_FREE_TEXT_INPUT_LENGTH = 3000;
export const MAX_SIGNATURE_TEXT_INPUT = 500;

export const INVALID_NAME_MESSAGE = 'Special characters in the name are not allowed.';
